module.exports = __webpack_public_path__ + "img/apple.1cfd5dba.svg";